module.exports = __webpack_public_path__ + "static/media/grey-eye.100b1b91.svg";